import { combineReducers } from 'redux';

import uiReducer from './ui/uiSlice';

import { configureStore } from '@reduxjs/toolkit';

const reducers = combineReducers({
  ui: uiReducer,
});

export default configureStore({
  reducer: reducers,
  devTools: process.env.NODE_ENV !== 'production',
});
